import { blrfOperations } from 'app/state/ducks/blrf';

const { clear } = blrfOperations;

const getData = ( key, data ) => ( dispatch ) => {

    return dispatch ( blrfOperations.search( {
        endpoint: 'coin/dashboard/data',
        key, 
        data
    }) );

};

export {
    clear,
    getData
};
